interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'active' | 'muted'
  className?: string
  style?: React.CSSProperties
}

const variants = {
  default: 'border-vibe-border text-text-secondary',
  active: 'border-accent-primary text-accent-primary',
  muted: 'border-vibe-border text-text-muted',
}

export function Badge({ 
  children, 
  variant = 'default',
  className = '',
  style
}: BadgeProps) {
  return (
    <span 
      className={`
        inline-block px-2 py-0.5 border text-tiny font-mono uppercase tracking-wider rounded-sm
        ${variants[variant]}
        ${className}
      `}
      style={style}
    >
      {children}
    </span>
  )
}
